import {NodeTypeEnum} from '../../types/NodeTypeEnum'
import {ParamFilters} from '../../types/paramFilters/paramFilters'

export const initialParamsFiltersConfig: ParamFilters = {
  id: '001',
  type: NodeTypeEnum.entryCondition,
  reentryDays: null,
  paramsSelectors: [
    {
      id: 0,
      selectedCategory: '',
      selectedParam: '',
      selectedParamType: '',
      conditional: null,
      selectedParamData: {
        operator: 'lessThan',
        value: null,
      },
    },
  ],
}
